<template>
  <div class="app-bg">
    <MainLayout>
      <router-view />
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from './layout/MainLayout.vue';
export default {
  name: 'App',
  components: { MainLayout }
};
</script>

<style>
.app-bg {
  min-height: 100vh;
  width: 100%;
  background: url('~@/assets/images/background.jpg') center center/cover no-repeat fixed;
  position: relative;
  z-index: 0;
  filter: blur(0px);
}
</style>